<div class="title">{{field.name}}</div>

<div class="list-items">
    <div class="list-item input-container" *ngFor="let item of field.value; index as index">
        <input type="text" class="title" [(ngModel)]="item.title" (ngModelChange)="commitChanges()" (focus)="onFocus('.title', index)" (blur)="editor.deselectNode()">
        <input type="text" class="content" [(ngModel)]="item.content" (ngModelChange)="commitChanges()" (focus)="onFocus('.content', index)" (blur)="editor.deselectNode()">
        <button class="no-style remove-item-button" type="button" (click)="removeItem(item)"><mat-icon svgIcon="close"></mat-icon></button>
    </div>
</div>

<div class="add-button-container">
    <button mat-flat-button color="accent" type="button" (click)="addNewItem()" trans>Add</button>
</div>